module.exports = __webpack_public_path__ + "img/device_am35_m_b.861479c6.png";